'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {allowedModesPropType} from '../AuthForm/AuthFormView';
import {AuthForm} from '../AuthForm';

export const modalOptions = {
  isLegacy: true,
  backdropClickToClose: false,
  hardwareBackButtonClose: false,
  keepOpenOnNav: true,
  modalProps: {
    modalClass: 'AuthModalWrapper',
    useScrollWrapper: false,
  },
};

export class AuthModalComponent extends Component {
  static propTypes = {
    className: T.string,
    allowedModes: allowedModesPropType,
    initialMode: allowedModesPropType,
    showCloseButton: T.bool,

    onCancel: T.func.isRequired,
  };

  static defaultProps = {
    showCloseButton: true,
  };

  render() {
    return (
      <AuthForm
        {...this.props}
        className={classNames("card full-height-flex modal-auto-centered", this.props.className, {
          'modal-auto-centered-top': this.props.keyboardHeight > 0,
        })}
        isModal={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/components/AuthModal/AuthModalComponent.js